import algoliasearch from 'algoliasearch'
import { algoliaConfig } from './config'


export const algoliaClient = algoliasearch(algoliaConfig.appID, algoliaConfig.searchOnlyAPIKey)


// WEBPACK FOOTER //
// ./src/core/algolia/algolia.js